/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BagDefaultPaymentMethodQueryVariables = Exact<{ [key: string]: never }>;

export type BagDefaultPaymentMethodQuery = {
  readonly paymentProfile: {
    readonly __typename: 'PaymentProfile';
    readonly id: string;
    readonly defaultCardId: string | null;
  } | null;
};

export type BagSetDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: string;
}>;

export type BagSetDefaultPaymentMethodMutation = {
  readonly setDefaultPaymentMethod: {
    readonly __typename: 'PaymentProfile';
    readonly id: string;
    readonly defaultCardId: string | null;
  };
};

export const BagDefaultPaymentMethodDocument = gql`
  query BagDefaultPaymentMethod {
    paymentProfile {
      __typename
      id
      defaultCardId
    }
  }
`;

export function useBagDefaultPaymentMethodQuery(
  options?: Omit<Urql.UseQueryArgs<BagDefaultPaymentMethodQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagDefaultPaymentMethodQuery, BagDefaultPaymentMethodQueryVariables>({
    query: BagDefaultPaymentMethodDocument,
    ...options,
  });
}
export const BagSetDefaultPaymentMethodDocument = gql`
  mutation BagSetDefaultPaymentMethod($paymentMethodId: String!) {
    setDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
      __typename
      id
      defaultCardId
    }
  }
`;

export function useBagSetDefaultPaymentMethodMutation() {
  return Urql.useMutation<
    BagSetDefaultPaymentMethodMutation,
    BagSetDefaultPaymentMethodMutationVariables
  >(BagSetDefaultPaymentMethodDocument);
}
